import { List } from 'immutable';
import { commitmentDocConstants } from '../constants';

export function commitmentDocs(state = {}, action) {
  switch (action.type) {
    case commitmentDocConstants.COMMITMENT_DOC_LIST_LOADING:
      return {
        ...state,
        listLoading: true
      };
    case commitmentDocConstants.COMMITMENT_DOC_LIST_SUCCESS:
      return {
        ...state,
        items: List(action.response),
        listLoading: false
      };
    case commitmentDocConstants.COMMITMENT_DOC_LIST_FAILURE:
      return {
        ...state,
        listLoading: false,
        items: [],
        listError: action.error
      };

    case commitmentDocConstants.COMMITMENT_DOC_LIST_CLEAR:
      return {
        ...state,
        items: null
      };

    case commitmentDocConstants.COMMITMENT_DOC_CREATE_LOADING:
      return {
        ...state,
        createLoading: true
      };
    case commitmentDocConstants.COMMITMENT_DOC_CREATE_SUCCESS: {
      const items = state.items ? state.items : List();
      return {
        ...state,
        items: items.push(action.response),
        createLoading: false,
        createError: null
      };
    }
    case commitmentDocConstants.COMMITMENT_DOC_CREATE_FAILURE:
      return {
        ...state,
        createLoading: false,
        createError: action.error
      };

    case commitmentDocConstants.COMMITMENT_DOC_EDIT_LOADING:
      return {
        ...state,
        editLoading: true
      };
    case commitmentDocConstants.COMMITMENT_DOC_EDIT_SUCCESS: {
      if (!state.items) {
        return state;
      }

      const commitmentDocIndex = state.items.findIndex(val => val.id == action.response.id);

      if (commitmentDocIndex == -1) {
        return state;
      }

      return {
        ...state,
        items: state.items.set(commitmentDocIndex, action.response),
        editLoading: false,
        editError: null
      };
    }
    case commitmentDocConstants.COMMITMENT_DOC_EDIT_FAILURE:
      return {
        ...state,
        editLoading: false,
        editError: action.error
      };

    case commitmentDocConstants.COMMITMENT_DOC_DELETE_LOADING:
      return {
        ...state,
        deleteLoading: true
      };
    case commitmentDocConstants.COMMITMENT_DOC_DELETE_SUCCESS: {
      const { commitmentDocId } = action;

      if (!state.items) {
        return state;
      }

      const commitmentDocIndex = state.items.findIndex(val => val.id == commitmentDocId);

      if (commitmentDocIndex == -1) {
        return state;
      }

      return {
        ...state,
        items: state.items.delete(commitmentDocIndex),
        deleteLoading: false,
        deleteError: null
      };
    }
    case commitmentDocConstants.COMMITMENT_DOC_DELETE_FAILURE:
      return {
        ...state,
        deleteLoading: false,
        deleteError: action.error
      };
    case commitmentDocConstants.COMMITMENT_DOC_ERROR_RELOAD:
      return {
        ...state,
        createError: null,
        editError: null
      };

    default:
      return state;
  }
}
